/**
 * Auto Session Started / Ended — 세션 관리
 * visibilitychange + 5분 idle 타이머
 * sessionStorage에 session_id 저장 (탭 단위)
 */

const IDLE_TIMEOUT_MS = 5 * 60 * 1000; // 5분
const SESSION_KEY = "__ax_session_id";
const SESSION_START_KEY = "__ax_session_start";

function generateSessionId() {
  // 간단한 uuid-like string (crypto 없는 환경 호환)
  try {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
      return crypto.randomUUID();
    }
  } catch (e) {
    // fallback
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0;
    var v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function getSessionId() {
  try {
    return sessionStorage.getItem(SESSION_KEY);
  } catch (e) {
    return null;
  }
}

function setSessionId(id) {
  try {
    sessionStorage.setItem(SESSION_KEY, id);
    sessionStorage.setItem(SESSION_START_KEY, String(Date.now()));
  } catch (e) {
    // sessionStorage 접근 불가 시 무시
  }
}

function getSessionDuration() {
  try {
    var start = sessionStorage.getItem(SESSION_START_KEY);
    if (!start) return 0;
    return Math.round((Date.now() - Number(start)) / 1000);
  } catch (e) {
    return 0;
  }
}

function clearSession() {
  try {
    sessionStorage.removeItem(SESSION_KEY);
    sessionStorage.removeItem(SESSION_START_KEY);
  } catch (e) {
    // 무시
  }
}

export function initSession(mixpanel) {
  var idleTimer = null;
  var sessionEnded = false;
  var lastResetTime = 0;

  function startSession() {
    try {
      var existingId = getSessionId();
      if (existingId) return; // 이미 세션 있으면 재시작하지 않음

      var sessionId = generateSessionId();
      setSessionId(sessionId);
      sessionEnded = false;

      mixpanel.track("Auto Session Started", {
        session_id: sessionId,
      });
    } catch (e) {
      // 조용히 무시
    }
  }

  function endSession() {
    try {
      if (sessionEnded) return;

      var sessionId = getSessionId();
      if (!sessionId) return;

      sessionEnded = true;
      var duration = getSessionDuration();

      mixpanel.track("Auto Session Ended", {
        session_id: sessionId,
        duration_seconds: duration,
      });

      clearSession();
    } catch (e) {
      // 조용히 무시
    }
  }

  function resetIdleTimer() {
    try {
      // 10초 이내 연속 호출 무시 (scroll 등 고빈도 이벤트 최적화)
      var now = Date.now();
      if (now - lastResetTime < 10000) return;
      lastResetTime = now;

      if (idleTimer) clearTimeout(idleTimer);
      idleTimer = setTimeout(function () {
        try {
          endSession();
        } catch (e) {
          // 무시
        }
      }, IDLE_TIMEOUT_MS);
    } catch (e) {
      // 무시
    }
  }

  // 페이지 visible → 세션 시작, hidden → 세션 종료
  function handleVisibility() {
    try {
      if (document.visibilityState === "visible") {
        startSession();
        resetIdleTimer();
      } else {
        endSession();
        if (idleTimer) clearTimeout(idleTimer);
      }
    } catch (e) {
      // 무시
    }
  }

  // 초기화
  if (document.visibilityState === "visible") {
    startSession();
    resetIdleTimer();
  }

  document.addEventListener("visibilitychange", handleVisibility, { passive: true, capture: true });

  // 사용자 활동 시 idle 타이머 리셋
  var activityEvents = ["click", "keydown", "scroll", "touchstart"];
  activityEvents.forEach(function (eventName) {
    document.addEventListener(eventName, resetIdleTimer, { passive: true, capture: true });
  });

  // beforeunload에서 세션 종료
  window.addEventListener("beforeunload", function () {
    try {
      endSession();
    } catch (e) {
      // 무시
    }
  });
}
